import { useEffect } from "react";
import { useTheme } from "@/shared/hooks/useTheme";
import { useAuth } from "@/shared/hooks/useAuth";
import { apiClient } from "@/shared/lib/api/apiClient";

export function ThemeSyncProvider({ children }: { children: React.ReactNode }) {
  const { theme, setTheme } = useTheme();
  const { user } = useAuth();

  // Load theme from server when user logs in
  useEffect(() => {
    if (user?.id && user?.theme) {
      const serverTheme = user.theme as "light" | "dark" | "system";
      if (serverTheme && serverTheme !== theme) {
        setTheme(serverTheme);
      }
    }
  }, [user?.id, user?.theme]);

  // Save theme to server when it changes
  useEffect(() => {
    if (user?.id && theme) {
      const saveTheme = async () => {
        try {
          await apiClient.users.updatePreferences(user.id, { theme });
        } catch {
          // theme sync is best-effort
        }
      };

      // Debounce the save to avoid too many requests
      const timeoutId = setTimeout(saveTheme, 500);
      return () => clearTimeout(timeoutId);
    }
    return undefined;
  }, [theme, user?.id]);

  return <>{children}</>;
}
